/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_CashInputs */

const en_method_cash = /** @type {(inputs: Method_CashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cash`)
};

const he_method_cash = /** @type {(inputs: Method_CashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מזומן`)
};

/**
* | output |
* | --- |
* | "cash" |
*
* @param {Method_CashInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const method_cash = /** @type {((inputs?: Method_CashInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_CashInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_method_cash(inputs)
	return he_method_cash(inputs)
});